/**
 * GebaeudePanel — Wrapper mit Sub-Tabs:
 *   Gebäudedaten | Raumbuch | Bestandsanalyse
 * Wird im ContentPanel unter activeSection === 'gebaeude' gerendert.
 */

import { useState } from 'react'
import { BuildingDataPanel } from './BuildingDataPanel'
import { RaumbuchListPanel } from '../raumbuch/RaumbuchListPanel'
import { BestandsanalysePanel } from './BestandsanalysePanel'

type GebaeudeTab = 'daten' | 'raumbuch' | 'analyse'

const TABS: { id: GebaeudeTab; label: string }[] = [
  { id: 'daten',    label: 'Gebäudedaten' },
  { id: 'raumbuch', label: 'Raumbuch' },
  { id: 'analyse',  label: 'Bestandsanalyse' },
]

export function GebaeudePanel() {
  const [tab, setTab] = useState<GebaeudeTab>('daten')

  return (
    <div className="gebaeude-panel">
      {/* Sub-Tab Navigation */}
      <nav className="gebaeude-tabs">
        {TABS.map(t => (
          <button
            key={t.id}
            className={`gebaeude-tabs__btn${tab === t.id ? ' gebaeude-tabs__btn--active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {/* Tab Content */}
      <div className="gebaeude-tabs__content">
        {tab === 'daten' && <BuildingDataPanel />}
        {tab === 'raumbuch' && <RaumbuchListPanel />}
        {tab === 'analyse' && <BestandsanalysePanel />}
      </div>
    </div>
  )
}
